import React, { useEffect, useState } from 'react';
import { useTable, usePagination } from 'react-table';
import { CAR_DEAL } from '../../constants/columns';

// components
import EmptyData from '../../components/EmptyData/EmptyData';
import Table from '../../components/Table/Table';

// icons
import icon from '../../brand/generated/buttonIcons/addDeal.svg';

import { textStyles } from '../../constants/textStyles';
import getDeals from '../../api/deals/getDeals';
import getItems from '../../api/cars/getItems';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';

const columns = CAR_DEAL;

const CarDeal = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    getItems({ id: id })
      .then((res) => {
        getDeals({
          vin: res.data.cars[0].vin,
        })
          .then((res) => {
            setDeals(res.data.deals);
          })
          .finally(() => {
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
          });
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const handleNavigate = (index) => {
    navigate(`/deals/deal/${deals.find((item) => item.id === index).id}/main-info`, {
      state: deals.find((item) => item.id === index),
    });
  };

  const table = useTable(
    {
      columns,
      data: deals,
    },
    usePagination
  );

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {deals.length ? (
        <div style={{ padding: '30px 20px', backgroundColor: 'white', border: '1px solid #e0e0e0', marginTop: '20px' }}>
          <p style={textStyles.formTitle}>Сделка</p>
          <br />
          <Table table={table} handleNavigate={handleNavigate} />
        </div>
      ) : (
        <EmptyData
          title={'Сделка'}
          subtitle={'Это автомобиль пока не участвует ни в одной сделке'}
          // action={'Создать сделку с автомобилем'}
          icon={icon}
        />
      )}
    </>
  );
};

export default CarDeal;
